import ThemeSwitch from "@/features/menu/settings/ThemeSwitch";

export default function Theme() {
    return <ThemeSwitch />;
}
